<template>
  <!--<div
    class="ferris-wheel"
    :style="{width: width.toString() + 'px', height: height.toString() + 'px', background}"
  >-->
    <div
    class="ferris-wheel"
    :class="imageHover ? 'rotate-paused' : 'rotate-running'"
    :style="{width: width.toString() + 'px', height: height.toString() + 'px', background}"
  >
    <div
      v-for="(item, index) in circleData"
      :key="index.toString() + 'circleData'"
      class="circle"
      :class="imageHover ? 'rotate-paused' : 'rotate-running'"
      :style="circlePosition(index)"
      @click="wheelClick(item)"
      @mouseover="wheelMouseover(item)"
      @mouseout="wheelMouseout(item)"
    >
      <img :src="item.icon">
      <span class="circle-span">{{ item.resourceDesc }}</span>
    </div>
  </div>
</template>
<script>
export default({
  name: 'FerrisWheel',
  props:{
    width:{
      type: Number,
      default: 800
    },
    height:{
      type: Number,
      default: 800
    },
    circleImageRadius:{
      type: Number,
      default: 100
    },
    background:{
      type: String,
      default: ''
    },
    circleData:{
      type: Array,
      default: () =>{
        return [
          /*{
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': 1526882227000,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1526882236000,
            'recordVersion': 0,
            'resourceId': '8',
            'url': '',
            'path': null,
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-access-plat.png'),
            'displayOrder': 2,
            'hidden': 0,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': null,
            'recordVersion': null,
            'resourceId': '9',
            'url': '',
            'path': null,
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1554876233000,
            'recordVersion': 0,
            'resourceId': '10',
            'url': '',
            'path': 'system/department.html',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-shiny-area.png'),
            'displayOrder': 2,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': null,
            'recordVersion': null,
            'resourceId': '11',
            'url': '',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': null,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': null,
            'recordVersion': null,
            'resourceId': '12',
            'url': 'http://222.179.155.108:30026/apm/autoLogin?authorization=',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': 1556437492000,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1556437499000,
            'recordVersion': null,
            'resourceId': '27',
            'url': '',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaacdcccc',
            'icon': require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          },
          {
            'isDelete': false,
            'createUser': null,
            'createDepartment': null,
            'createServerHost': null,
            'createTime': 1556437492000,
            'updateUser': null,
            'updateDepartment': null,
            'updateServerHost': null,
            'updateTime': 1556437499000,
            'recordVersion': null,
            'resourceId': '27',
            'url': '',
            'path': 'asdasd',
            'pathMethod': null,
            'resourceType': 2,
            'parentId': '3',
            'resourceDesc': 'aaaaa',
            'icon':require('../../images/ferris-wheel/circle-people-cloud.png'),
            'displayOrder': null,
            'hidden': null,
            'subResource': null
          }*/
        ];
      }
    }
  },
  data() {
    return{
      pointPosition: [], //位置信息
      pointAve:{
        ox: this.width / 2 - (this.circleImageRadius + 10) / 2,
        oy: this.height / 2 - (this.circleImageRadius + 10) / 2,
        r: Number(this.width / 2 - (this.circleImageRadius + 10) / 2)
      },  //圆信息
      imageHover: false //wheel是否有移入
    };
  },
  watch: {
    circleData(val) {
      this.getPointPosition(this.pointAve.r, this.pointAve.ox, this.pointAve.oy, val.length);
    }
  },
  created(){
    this.getPointPosition(this.pointAve.r, this.pointAve.ox, this.pointAve.oy, this.circleData.length);
  },
  mounted() {
  },
  methods:{
    //二级菜单-图标位置信息
    circlePosition(index) {
      //当前二级菜单数量
      return {'top': this.pointPosition[index].x + 'px', 'left': this.pointPosition[index].y + 'px'} ;
    },
    //获取二级菜单 等分圆的点的位置信息 r 半径 ox 圆心横坐标 oy 圆心纵坐标 count 等分点个数
    getPointPosition(r, ox, oy, count) {
      this.pointPosition = [];
      let radians = (Math.PI / 180) * Math.round(360 / count);
      for(let i = 0; i < count; i++){
        let x = ox + r * Math.sin(radians * i);
        let y = oy + r * Math.cos(radians * i) ;
        this.pointPosition.push({x,y});
      }
      console.log(this.pointPosition);
    },
    /**
     * 转动图片的点击
     */
    wheelClick(item){
      this.$emit('wheelClick', item);
    },
    /**
     * 转动图片的点击
     */
    wheelMouseover(item){
      this.imageHover = true;
      this.$emit('wheelMouseover', item);
    },
    /**
     * 转动图片的点击
     */
    wheelMouseout(item){
      this.imageHover = false;
      this.$emit('wheelMouseout', item);
    },
  }
});
</script>
<style scoped lang="less">
  @import "../../css/ferris-wheel/ferris-wheel";
</style>



// WEBPACK FOOTER //
// src/myPlugin/ferris-wheel/ferris-wheel.vue